import {ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ComponentDefinition} from '@formbird/types';
import {FormbirdInjectorService} from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ChangedDocumentService} from 'formbird-services';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';

interface DocumentDownloaderComponentDefinition extends ComponentDefinition {}

@Component({
  templateUrl: './document-downloader.component.html',
  styleUrls: ['./document-downloader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentDownloaderComponent extends AbstractComponent<DocumentDownloaderComponentDefinition> implements OnInit {
  @Input() isOpenInDocumentEditor = false;

  @Input() floatLabel: any;
  @Input() docs: object = {};
  @Input() toDownload: string;
  @Input() fileName: string;

  JSON_INDENT_COUNT = 4;
  defaultValue: any;
  offlineUtilService: any;
  currentDocumentService: any;
  currentOpenedDocument: any;
  notificationService: any;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.offlineUtilService = this.formbirdInjectorService.get('OfflineUtilService');
    this.currentDocumentService = this.formbirdInjectorService.get('CurrentDocumentService');
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
  }


  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);

    if (this.document && this.document.systemHeader &&
      (!(typeof this.document.systemHeader.currentVersion === 'undefined'
        || this.document.systemHeader.currentVersion === null
      ))
    ) {
      this.currentOpenedDocument = this.document;
    } else {
      this.currentOpenedDocument = this.template;
    }

    if (!this.currentOpenedDocument) {
      this.currentOpenedDocument = this.currentDocumentService.getDocumentData().document;
    }

  }

  download() {
    let downlodableDoc;

    if (this.toDownload) {
      try {
        downlodableDoc = JSON.parse(this.toDownload);
        this.createLinkAndDownload(downlodableDoc);
      } catch(e) {
        this.notificationService.error("Unable to parse document: " + e.message);
      }
    } else {
      this.createLinkAndDownload(this.currentOpenedDocument);
    }
  }

  createLinkAndDownload(doc) {
    const link: HTMLAnchorElement = document.createElement("a");
    link.setAttribute(
      'href',
      'data:Application/octet-stream,' +
      encodeURIComponent(
        JSON.stringify(doc, null, this.JSON_INDENT_COUNT)
      )
    );

    link.download = this.fileName || 'template_' + doc.documentId +'.json';
    link.click();
    link.remove();
  };

}

